import React from 'react';

import CourseVimeoComponent from './CourseVimeoComponent';
import CourseBunnyComponent from './CourseBunnyComponent';
import { CourseVideoPlayerProps, usesNativePlayer } from './videoProvider';

const CourseVideoPlayer: React.FC<CourseVideoPlayerProps> = (props) =>
  usesNativePlayer(props.url) ? (
    <CourseBunnyComponent {...props} />
  ) : (
    <CourseVimeoComponent {...props} />
  );

export default CourseVideoPlayer;
